/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BillDetailPayee
 */
export interface BillDetailPayee {
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee
     */
    'bankCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee
     */
    'bankName': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee
     */
    'branchCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee
     */
    'branchName': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee
     */
    'accountType': BillDetailPayeeAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof BillDetailPayee
     */
    'accountHolder': string;
    /**
     * 
     * @type {boolean}
     * @memberof BillDetailPayee
     */
    'isSaved': boolean;
}

export const BillDetailPayeeAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    depositAccount: 'DEPOSIT_ACCOUNT',
    otherAccount: 'OTHER_ACCOUNT'
} as const;

export type BillDetailPayeeAccountTypeEnum = typeof BillDetailPayeeAccountTypeEnum[keyof typeof BillDetailPayeeAccountTypeEnum];


